module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('stage-bar', {
    attrs: {
      "bar-class": _vm.level || "olive",
      "classes": "small",
      "tags": _vm.tags,
      "min": _vm.min,
      "max": _vm.max,
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d68745a8","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/ContractStageBar.vue
// module id = 308
// module chunks = 0